export const Start02Icon = ({ ...props }: React.SVGProps<SVGSVGElement>) => {
   return (
      <svg
         width="24"
         height="24"
         viewBox="0 0 24 24"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         {...props}
      >
         <path
            d="M9.92773 15.4851C9.83853 15.1394 9.65833 14.8239 9.40585 14.5714C9.15338 14.3189 8.83786 14.1387 8.49213 14.0495L2.36312 12.4691C2.25855 12.4394 2.16652 12.3764 2.10099 12.2897C2.03546 12.203 2 12.0972 2 11.9885C2 11.8798 2.03546 11.7741 2.10099 11.6874C2.16652 11.6007 2.25855 11.5377 2.36312 11.508L8.49213 9.92655C8.83774 9.83744 9.15317 9.65738 9.40564 9.40509C9.6581 9.15281 9.83838 8.8375 9.92773 8.49195L11.5082 2.36294C11.5376 2.25796 11.6005 2.16547 11.6873 2.09959C11.7742 2.03371 11.8802 1.99805 11.9892 1.99805C12.0982 1.99805 12.2042 2.03371 12.2911 2.09959C12.3779 2.16547 12.4409 2.25796 12.4702 2.36294L14.0497 8.49195C14.1389 8.83768 14.3191 9.1532 14.5716 9.40567C14.824 9.65815 15.1396 9.83835 15.4853 9.92755L21.6143 11.507C21.7197 11.5361 21.8126 11.5989 21.8789 11.6859C21.9451 11.7729 21.981 11.8792 21.981 11.9885C21.981 12.0979 21.9451 12.2042 21.8789 12.2912C21.8126 12.3781 21.7197 12.441 21.6143 12.4701L15.4853 14.0495C15.1396 14.1387 14.824 14.3189 14.5716 14.5714C14.3191 14.8239 14.1389 15.1394 14.0497 15.4851L12.4692 21.6141C12.4399 21.7191 12.3769 21.8116 12.2901 21.8775C12.2032 21.9434 12.0972 21.979 11.9882 21.979C11.8792 21.979 11.7732 21.9434 11.6863 21.8775C11.5995 21.8116 11.5366 21.7191 11.5072 21.6141L9.92773 15.4851Z"
            fill="#D474D9"
            fillOpacity="0.3"
            stroke="currentColor"
            strokeWidth="1.22957"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M19.9805 2.99707V6.99316"
            stroke="currentColor"
            strokeWidth="1.22957"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M21.9805 4.99512H17.9844"
            stroke="currentColor"
            strokeWidth="1.22957"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M3.99609 16.9834V18.9814"
            stroke="currentColor"
            strokeWidth="1.22957"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M4.99414 17.9824H2.99609"
            stroke="currentColor"
            strokeWidth="1.22957"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   )
}
